<template>
  <div class="email-block">
    <template v-if="isNewEmailSent">
      <h2 class="text-center">{{ $t("emailLabel.checkEmail") }}</h2>
      <v-card-title>
        <div class="font16 text-center">
          <p>{{ $t("emailLabel.newEmailSend") }}</p>

          <b>Note:</b> {{ $t("emailLabel.checkSpamFolder") }}
        </div>
      </v-card-title>
      <v-card-text class="text-center">
        <v-btn class="logo-color" color="primary" text @click="sendEmailInvite()">{{ $t("emailLabel.resendLink") }}</v-btn>
      </v-card-text>
    </template>
    <template v-else>
      <h2 class="text-center">{{ $t("emailLabel.linkExpired") }}</h2>
      <v-card-title>
        <div class="font16 text-center">{{ $t("emailLabel.tryNewLink") }}</div>
      </v-card-title>
      <v-card-text>
        <v-btn color="info" block @click="sendEmailInvite()">{{ $t("emailLabel.sendNewLink") }}</v-btn>
      </v-card-text>
    </template>
    <p class="text-center mt-6 mt-sm-2">
      {{ $t("emailLabel.alreadyHaveAnAccount") }}
      <a class="logo-color" @click.prevent="goToLogin()">{{ $t("signIn") }}</a>
    </p>
  </div>
</template>

<script>
import Auth from "@aws-amplify/auth";

export default {
  props: {
    userEmail: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isNewEmailSent: false,
    };
  },
  methods: {
    goToLogin() {
      this.$emit("backToLogin", true);
    },
    async sendEmailInvite() {
      await Auth.forgotPassword(this.userEmail.toLowerCase(), { resetMedium: "link" });
      this.isNewEmailSent = true;
    },
  },
};
</script>

<style scoped>
.email-block {
  padding: 0 40px;
}
.email-block .font16 {
  font-size: 16px;
  word-break: normal;
}
.v-application .email-block .v-btn {
  text-transform: unset;
}
.v-application .email-block .logo-color {
  color: #0091ff !important;
}
</style>
